/*global
    jQuery
*/
(function ($) {
    var showButtonMenu = function(e) {
        var $this = $(this);

        var $menu = $this.siblings('ul.button-menu');

        $menu.fadeIn(300);
        e.preventDefault();
    }

    var hideButtonMenu = function(e) {
        var $this = $(this);

        var $menu = $this.siblings('ul.button-menu');
        $menu.fadeOut(300);
    }

    $('button.hide-pet').on('click', showButtonMenu);
    $('button.hide-pet').on('blur', hideButtonMenu);
}(jQuery));
